import React from 'react';
import Modal from 'react-modal';
import { useSelector, useDispatch } from 'react-redux';
import { closeConfirm } from '../../store/confirmSlice';

export default function ConfirmModal() {
  const dispatch = useDispatch();
  const { isOpen, options, resolver } = useSelector(s => s.confirm);

  const handleClose = (answer) => {
    resolver(answer);
    dispatch(closeConfirm());
  };

  if (!isOpen) return null;

  return (
    <Modal
      isOpen={true}
      onRequestClose={() => handleClose(false)}
      className="confirmation-modal"
      overlayClassName="confirmation-overlay"
      ariaHideApp={false}
    >
        <div className="confirmation-content">
            {options.title && <h2>{options.title}</h2>}
            <p>{options.message}</p>            
            <button onClick={() => handleClose(true)}>Conferma</button>
            <button onClick={() => handleClose(false)}>Annulla</button>           
       </div> 
    </Modal>
  );
}